import styled, { css } from "styled-components"
import { mq } from "common/mediaQuery"

export const SideContent = styled.div`
  flex: 1;
  order: 0;

  ${mq.tabletWide} {
    min-width: 30rem;
  }
`

export const SideMedia = styled.div`
  position: relative;
  flex: ${p => p.ratio ? p.ratio : "3"};
  margin-bottom: 5rem;

  ${mq.tabletWide} {
    margin-bottom: 0;
  }
  img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  ${p =>
    p.firstOnMobile &&
    css`
      order: -1;

      ${mq.tabletWide} {
        order: 0;
      }
    `}
  ${p =>
    p.lastOnMobile &&
    css`
      order: 1;
      margin-bottom: 0;

      ${mq.tabletWide} {
        order: 0;
      }
    `}
`

export const SpreadContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${mq.tabletWide}{
    flex-direction: row;
    justify-content: space-between;
  }

  ${SideContent} + ${SideMedia},
  ${SideMedia} + ${SideContent} {
    ${mq.tabletWide}{
      margin-left: 5rem;
    }

    ${mq.desktop}{
      margin-left: 11rem;
    }
  }
`



// WEBPACK FOOTER //
// ./src/componentsStyled/LoggedOut.js